import convertFormData from '@module/utils/convertFormData';
import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type {
  FanRankCancelParams,
  FanRankListParams,
  FanRankWriteParams,
  FetchFanListParams,
  FetchFanListResponse,
  FetchFanRankEditResponse,
  FetchFanRankListResponse,
} from './type';

export const fetchFanList = async (fetchFanListParams: FetchFanListParams) => {
  const res = await fetchExtended(`/v1/fan`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fetchFanListParams),
  });

  const result = await res.json();

  return result as FetchFanListResponse;
};
export const fetchFanRankList = async (fanRankListParams: FanRankListParams) => {
  const res = await fetchExtended(`/v1/fan/rank`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fanRankListParams),
  });

  const result = await res.json();

  return result as FetchFanRankListResponse;
};

export const fetchFanRankWrite = async (fanRankWriteParams: FanRankWriteParams) => {
  const res = await fetchExtended(`/v1/fan/write_ever`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fanRankWriteParams),
  });

  const result = await res.json();

  return result as FetchFanRankEditResponse;
};

export const fetchFanRankCancel = async (fanRankCancelParams: FanRankCancelParams) => {
  const res = await fetchExtended(`/v1/fan/cancel_ever`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fanRankCancelParams),
  });

  const result = await res.json();

  return result as FetchFanRankEditResponse;
};
